import React from 'react';
import { FormattedMessage } from 'react-intl';

const ClientCell = (props) => {
  const getClient = props?.cell?.row?.original?.client;
  return (
    <>
      <p>
        {getClient ? (
          getClient?.name
        ) : (
          <FormattedMessage id="common.all.clients" />
        )}
      </p>
    </>
  );
};

export default ClientCell;
